export class SearchFacetFilter {
  public token: string;
  public value: string;
  public label: string;
  public query: string;
  public field: string;
  public excludedFacet: boolean;
  public isString: boolean;

  constructor() {
    this.token = '';
    this.value = '';
    this.label = '';
    this.query = '';
    this.field = '';
    this.excludedFacet = false;
    this.isString = false;
  }
}
